import React, { useState } from 'react';
import CustomerRegModal from '../../components/AdminModal/CustomerRegModal';
import { FaUserCheck,FaUserSlash } from "react-icons/fa";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { RxLapTimer } from "react-icons/rx";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';

function UserCustomers() {

  const [filter, setFilter] = useState("All");

  // Sample data
  const customers = [
    { name: "Name 1", mail: "Mail ID", joinDate: "10/11/2024", phone: "Number", status: "Inactive" },
    { name: "Name 2", mail: "Mail ID", joinDate: "10/11/2024", phone: "Number", status: "Inactive" },
    { name: "Name 3", mail: "Mail ID", joinDate: "10/11/2024", phone: "Number", status: "Active" },
    { name: "Name 4", mail: "Mail ID", joinDate: "10/11/2024", phone: "Number", status: "Inactive" },
    { name: "Name 5", mail: "Mail ID", joinDate: "10/11/2024", phone: "Number", status: "Pending" },
    { name: "Name 6", mail: "Mail ID", joinDate: "10/11/2024", phone: "Number", status: "Inactive" },
    { name: "Name 7", mail: "Mail ID", joinDate: "10/11/2024", phone: "Number", status: "Inactive" },
  ];

  // Filter customers based on the selected filter
  const filteredCustomers = filter === "All" ? customers : customers.filter((customer) => customer.status === filter);

  return (
    <div className="container mx-auto p-4">
      {/* Add Customer Button */}
      <div className="flex justify-end mb-4">
        
        <CustomerRegModal/>
      </div>

      {/* Tabs Section */}
      <div className="flex items-center justify-between border-b border-gray-300 w-full mb-5">
  <button
    onClick={() => setFilter("All")}
    className={`flex flex-col items-center gap-1 ${
      filter === "All" ? "text-green-600" : "text-gray-400"
    }`}
  >
    <div className="flex items-center gap-2">
      <MdOutlineAccountBalanceWallet className='text-xl' />
      <span className="font-semibold">All</span>
    </div>
    {filter === "All" && <div className="w-full h-1 bg-green-600"></div>}
  </button>

  <button
    onClick={() => setFilter("Pending")}
    className={`flex flex-col items-center gap-1 ${
      filter === "Pending" ? "text-green-600" : "text-gray-400"
    }`}
  >
    <div className="flex items-center gap-2">
    <RxLapTimer className="text-xl" />
      <span className="font-medium">Pending</span>
    </div>
    {filter === "Pending" && <div className="w-full h-1 bg-green-600"></div>}
  </button>

  <button
    onClick={() => setFilter("Active")}
    className={`flex flex-col items-center gap-1 ${
      filter === "Active" ? "text-green-600" : "text-gray-400"
    }`}
  >
    <div className="flex items-center gap-2">
      <FaUserCheck className="text-xl" />
      <span className="font-medium">Active</span>
    </div>
    {filter === "Active" && <div className="w-full h-1 bg-green-600"></div>}
  </button>

  <button
    onClick={() => setFilter("Inactive")}
    className={`flex flex-col items-center gap-1 ${
      filter === "Inactive" ? "text-green-600" : "text-gray-400"
    }`}
  >
    <div className="flex items-center gap-2">
    <FaUserSlash className="text-xl" />
      <span className="font-medium">Inactive</span>
    </div>
    {filter === "Inactive" && <div className="w-full h-1 bg-green-600"></div>}
  </button>
</div>


      {/* Table Section */}
      <div className="overflow-x-auto mt-4">
  <table className="w-full text-left">
    <thead>
      <tr>
        <th className=" text-green-500 text-sm font-medium">Customer Name</th>
        <th className="py-3 px-4 text-green-500 text-sm font-medium">Location</th>
        <th className="py-3 px-4 text-green-500 text-sm font-medium">Join Date</th>
        <th className="py-3 px-4 text-green-500 text-sm font-medium">Status</th>
        <th className="py-3 px-4 text-green-500 text-sm font-medium">Sub Admin</th>
        <th className="py-3 px-4"></th>
      </tr>
    </thead>
    <tbody>
      {filteredCustomers.map((customer, index) => (
        <tr key={index}>
          <td>
            <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
              {customer.name || "Name"}
            </div>
          </td>
          <td className="py-3 px-4">
            <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
              {customer.mail || "Mail ID"}
            </div>
          </td>
          <td className="py-3 px-4">
            <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm flex items-center gap-2">
              {customer.joinDate || "10/11/2024"}
              <FaRegCalendarAlt className="text-gray-400 text-base" />
            </div>
          </td>
          <td className="py-3 px-4">
            <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
              {customer.phone || "Number"}
            </div>
          </td>
          <td className="py-3 px-4">
            <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
              {customer.status || "Inactive"}
            </div>
          </td>
          <td className="py-3 px-4 text-right">
          <Link to="/admin_customer_view" className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100">
              VIEW
            </Link>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

    </div>
  );
}

export default UserCustomers;
